<div class="lg:row-span-4 w-full">
  <!-- Tipo de Comprobante -->
  <div class="mb-4">
    <label class="block text-sm font-medium text-gray-700 mb-2">Tipo de Comprobante</label>
    <div class="flex justify-center gap-2">
      @for(documento of tipo_documentos; track $index) {
      <button
        class="px-5 py-2 rounded-lg font-medium"
        [class]="
          documento == formProcesarVenta().controlValue().tipo_documento
            ? 'bg-blue-600 text-white hover:bg-blue-700'
            : 'bg-gray-200 hover:bg-gray-300 text-gray-700'
        "
        (click)="selectTipoDocumento(documento)"
      >
        {{ documento.split('_').join(' ') }}
      </button>
      }
    </div>
  </div>
  <!-- Cliente -->
  @if(showCliente() == true) {
  <div class="mb-4">
    <app-buscador-cliente [(cliente)]="formProcesarVenta().controlValue().cliente" />
  </div>
  }
  <!-- botón emitir -->
  <div class="flex justify-center mt-6">
    <app-button
      [label]="
        'Emitir ' +
        formProcesarVenta().controlValue().tipo_documento.split('_').join(' ').toLowerCase()
      "
      icon="bi bi-send"
      variant="success"
      (onClick)="emitirComprobante()"
    />
  </div>
</div>
